import {Action, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {CurrentUserInfo, SessionState} from "./index";

const initialState: SessionState = {
    user: null,
    initialized: false,
    message: "",
    locale: localStorage.getItem("locale") || "",
    themeMode: "light",
}


const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        locale_resolve(state: SessionState, action: PayloadAction<string>) {
            state.locale = action.payload
        },
        init_error(state: SessionState, action: PayloadAction<string>) {
          state.message = action.payload;
        },
        init_session(state: SessionState, action: PayloadAction<string>) {},
        logout(state: SessionState, action: Action) {
            state.user = null;
            state.message = "";
            state.initialized = false;
        },
        userProfileResolved(state: SessionState, action: PayloadAction<CurrentUserInfo>) {
            state.user = action.payload;
            state.initialized = true;
        },
        setThemeMode(state, action: PayloadAction<"light" | "dark">) {
            state.themeMode = action.payload
        },
        setLocale(state, action: PayloadAction<string>) {
            state.locale = action.payload;
        }
    },
});

export const {
    locale_resolve,
    setLocale,
    logout,
    setThemeMode,
    userProfileResolved,
    init_error,
    init_session
} = sessionSlice.actions
export const reducer = sessionSlice.reducer;




